import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
import databus, { Origins } from '@ykz/ykz-http/core';
/* eslint-disable */
/* 任务组件
 * <component-task-entry :can-show-box="!isLevelBox&&!isShowUserCoupon"  v-if="promoter.isPromoter"></component-task-entry>
 */
import ComponentTaskBox from '@/components/productDetail/task_box.vue';
import ComponentWelfareTask from '@/components/productDetail/welfare_task_component.vue';
import ComponentrewardToolBox from '@/components/productDetail/reward_tool_box.vue';
export default {
  name: "task_entry",
  data: function data() {
    return {
      goodId: getUrlParams("goodId") || "",
      //商品id
      weChatId: getUrlParams('weChatId') || window.weChatId,
      taskList: [],
      //任务列表数据
      task: {},
      //仅有一个任务的数据
      unTask: {},
      //未领取的任务数据对象
      isNewTask: false,
      //是否有新的任务
      hasShowWelfarePop: false //是否已经显示过限时福利弹框
    };
  },

  components: {
    ComponentTaskBox: ComponentTaskBox,
    ComponentWelfareTask: ComponentWelfareTask,
    ComponentrewardToolBox: ComponentrewardToolBox
  },
  props: {
    canShowBox: {},
    memberLevel: ''
  },
  watch: {
    canShowBox: function canShowBox(val) {
      //canShowBox，该字段有延迟，为确保能正常弹框，需要增加一个监听
      if (val && this.isNewTask && !this.hasShowWelfarePop) {
        this.hasShowWelfarePop = true;
        componentCenter.welfareTaskComponent.showWelfarePop();
      }
    }
  },
  filters: {
    interceptStr: function interceptStr(str) {
      return str ? str.slice(0, 6) + '...' : '出单任务奖励...';
    }
  },
  mounted: function mounted() {
    _typeof(window.componentCenter) == "object" || (window.componentCenter = {});
    window.componentCenter.taskEntry = this;
    console.log("ycf组件初始化：taskEntry");
    this.getBindOrderTask();
  },
  methods: {
    //跳转到任务详情页、拉新任务页
    goTaskDetailsPage: function goTaskDetailsPage() {
      if (this.task.type == 1) {
        //销售排行榜
        window.location.href = "/front/sales-rank/detail?activityId=" + this.task.taskId;
      } else if (this.task.type == 2) {
        //任务详情页
        window.location.href = "/front/promoter/taskDetails?weChatId=1" + "&taskId=" + this.task.taskId;
      } else if (this.task.type == 3) {
        //拉新任务页
        window.location.href = "/front/promoter/recruitTaskDetail?weChatId=1" + "&taskId=" + this.task.taskId;
      } else if (this.task.type == 4) {
        //出单奖励详情页
        window.location.href = "/front/promoter/saleAward?weChatId=1" + "&taskId=" + this.task.taskId;
      } else {
        //显示任务列表弹框
        componentCenter.welfareTaskComponent.openWelfareList();
      }
    },
    //获取商品绑定的下单任务
    getBindOrderTask: function getBindOrderTask() {
      var that = this,
        selectCity = ""; //用户首页所选择的城市名称
      if (localStorage.getItem("shopping_mall_city")) {
        selectCity = JSON.parse(localStorage.getItem("shopping_mall_city")).cityName;
      }
      databus({
        url: "/api/ordertask/getBindOrderTask",
        type: "get",
        origin: Origins.API_ACT,
        data: {
          goodsId: this.goodId,
          selectCity: selectCity,
          pageType: 1,
          memberLevel: that.memberLevel
        },
        success: function success(res) {
          if (res.code == 1000 && res.bcode == 100) {
            res.content = res.content || {};
            res.content.list = res.content.list || {};
            that.taskList = res.content.list[that.goodId] || [];
            if (that.taskList.length > 1) {
              var local_taskId = localStorage.getItem("welfare_pop_" + that.goodId);
              if (local_taskId) {
                for (var i in that.taskList) {
                  if (local_taskId.split("_").indexOf(that.taskList[i].taskId + "") == -1) {
                    that.isNewTask = true;
                    break;
                  }
                }
              } else {
                that.isNewTask = true;
              }
              that.isNewTask && that.canShowBox && !that.hasShowWelfarePop && that.$nextTick(function () {
                localStorage.setItem("welfare_pop_" + that.goodId, function () {
                  var val = ""; //多个任务id的值，用"_"连接，如123_456_789
                  for (var _i in that.taskList) {
                    val += that.taskList[_i].taskId + "_";
                  }
                  return val.replace(/_$/, "");
                }());
                that.hasShowWelfarePop = true;
                componentCenter.welfareTaskComponent.showWelfarePop();
              });
            } else if (that.taskList.length == 1) {
              that.task = that.taskList[0] || {};
              if ((that.task.type == 2 || that.task.type == 3 || that.task.type == 4) && res.content.isShow && !that.task.hasRecTask) {
                that.unTask = that.task;
              }
            } else {
              //没有任务数据
            }
          }
        }
      });
    }
  }
};